/**
 * Only a same-site relative path is ever honored as a post-login redirect target.
 * Anything else — an absolute URL with a scheme, a protocol-relative `//host` (browsers
 * treat this as an absolute URL to `host`), or a backslash trick some parsers normalize
 * into a slash — falls back to the safe default instead of becoming an open redirect.
 */
export function sanitizeReturnUrl(raw: string | null | undefined, fallback: string): string {
  if (!raw) return fallback;
  if (!raw.startsWith("/") || raw.startsWith("//") || raw.includes("\\") || raw.includes("://")) {
    return fallback;
  }
  return raw;
}
